module.exports = __webpack_public_path__ + "/images/shop/icon/credit_card.svg";